module.exports = __webpack_public_path__ + "img/search.cb0471af.png";